import React, { useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import AOS from "aos";
import "aos/dist/aos.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "./Trainers.css";
import RegistrationModal2 from "../../components/RegistrationModal2";

const Trainers = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: false,
    });
  }, []);

  return (
    <>
      <section className="services-page">

        {/* Banner */}
        <div className="service-banner">
          <div className="overlay"></div>
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-6">
                <h1>Services</h1>
                <p>Professional Training for Your Furry Friend</p>
              </div>

              <div className="col-lg-6 text-end">
                <img
                  src={`${process.env.PUBLIC_URL}/assets/imgs/Services_header.png`}
                  alt="Pets"
                  className="img-fluid banner-pets"
                />
              </div>
            </div>
          </div>
        </div>

        {/* Trainers Card */}
        <div className="trainers-section">
          <div className="container">

            <div className="trainers-card">
            <div className="row">
              <div className="col-md-5">
                <div className="Community-content">
                  <h1 className="font-bold mb-4">
                    Trainer
                  </h1>
                  <p className="font-semibold">
                  Professional pet training services to help your furry friend become a well-behaved and happy companion. Our certified trainers use positive reinforcement techniques.
                  </p>
                  <p>
                  From basic obedience to advanced behavioral training, we offer customized programs tailored to your pet's unique needs and your lifestyle goals.

                  </p>
                  <a class="btn btn-dark rounded-pill px-4 w-mxcontent mt-4 font-semibold py-2" data-bs-toggle="modal" data-bs-target="#RegistrationModal2">
                    Join Us Now
                  </a>
                </div>
              </div>
              <div className="col-md-7 pe-0">
                <div className="Community-image">
                  <img
                    className="img-fluid dog-image"
                    src={`${process.env.PUBLIC_URL}/assets/imgs/service_img/trainers.jpeg`}
                    alt="Banner_1"
                  />
                </div>
              </div>
            </div>
          </div>
            

          </div>
        </div>

        {/* Registration Modal 2 for Service Providers */}
        <RegistrationModal2 preSelectedService="training" />
      </section>
    </>
  );
};
export default Trainers;
